import * as React from 'react';
import { format } from '../../../../utils';
import { useTheme } from '../../../../theme';
import { SegmentFragment } from '@websky/graphql';
import cn from 'classnames';
import ImageWithFallback from '../../../../ImageWithFallback';
import { useRenderers } from '../../../../renderProps';
import { useFlightIconFallbackSrc } from './hooks';

export interface Props {
	segment: SegmentFragment;
	singleFlight?: boolean;
	nextDay?: boolean;
}

const FlightInfo: React.FC<Props> = ({ segment, singleFlight, nextDay }) => {
	const theme = useTheme('DesktopFlightRoute').SegmentStyles;

	const fallbackSrc = useFlightIconFallbackSrc();

	const { renderFlightInfoIcon: RenderFlightInfoIconOverride = ImageWithFallback } = useRenderers();

	return (
		<div
			className={cn(theme.flightInfo, {
				[theme.flightInfo__singleFlight]: singleFlight,
				[theme.flightInfo__nextDay]: nextDay
			})}
		>
			<div className={theme.flightInfo__container}>
				<div className={cn(theme.flightInfo__icon)}>
					<RenderFlightInfoIconOverride
						src={segment.operatingAirline?.icon}
						fallbackSrc={fallbackSrc}
						alt={segment.operatingAirline?.name}
					/>
				</div>
				<div className={theme.flightInfo__date}>
					{format(segment.departure.date, 'dd MMM, eeeeee').replace('.', '')}
				</div>
			</div>

			{segment.operatingAirline?.name && (
				<div className={theme.flightInfo__airline}>{segment.operatingAirline.name}</div>
			)}
		</div>
	);
};

export default FlightInfo;
